/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPieSimple: {
  name: 'pie-simple';
  data: string;
} = {
  name: 'pie-simple',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 4.171c0-1.15 1.037-2.207 2.332-1.898a10.014 10.014 0 0 1 7.394 7.395c.31 1.295-.748 2.332-1.898 2.332H14a2 2 0 0 1-2-2V4.171Zm2 .08V10h5.748A8.016 8.016 0 0 0 14 4.252ZM9.943 3.18a1 1 0 0 1-.61 1.276 8 8 0 1 0 10.223 10.181 1 1 0 1 1 1.888.659C20.083 19.197 16.37 22 12 22 6.477 22 2 17.523 2 12 2 7.644 4.784 3.94 8.667 2.569a1 1 0 0 1 1.276.61Z" fill="currentColor"/></svg>`,
};
